import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from './AuthProvider';
import UniversalLayout from './UniversalLayout';
import './AuthenticatedLayout.css';

/**
 * Layout wrapper for authenticated pages
 * Redirects to home if not authenticated, otherwise uses UniversalLayout
 */
export function AuthenticatedLayout({ children, hideSidebar = false }) {
  const navigate = useNavigate();
  const { user, loading } = useAuthContext();

  // Redirect if not authenticated
  useEffect(() => {
    if (!loading && !user) {
      navigate('/');
    }
  }, [user, loading, navigate]);

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="auth-layout auth-layout--loading">
        <div className="auth-layout__loader">
          <div className="auth-layout__spinner" />
        </div>
      </div>
    );
  }

  // Don't render if not authenticated (will redirect)
  if (!user) {
    return null;
  }

  return (
    <UniversalLayout hideSidebar={hideSidebar}>
      {children}
    </UniversalLayout>
  );
}

export default AuthenticatedLayout;
